let subscribers = [];
let isLoading = false;
let activeRequests = 0;
let stopTimeout = null;

export const subscribe = (callback) => {
  subscribers.push(callback);
  // Notifica subito il nuovo subscriber dello stato corrente
  callback(isLoading);
};

export const unsubscribe = (callback) => {
  subscribers = subscribers.filter((cb) => cb !== callback);
};

export const startLoading = () => {
  if (stopTimeout) {
    clearTimeout(stopTimeout);
    stopTimeout = null;
  }
  activeRequests++;
  if (!isLoading) {
    isLoading = true;
    subscribers.forEach((cb) => cb(isLoading));
  }
};

export const stopLoading = (error = false) => {
  if (error) {
    activeRequests = 0;
    if (stopTimeout) {
      clearTimeout(stopTimeout);
      stopTimeout = null;
    }
    isLoading = false;
    subscribers.forEach((cb) => cb(isLoading));
    return;
  }
  if (activeRequests > 0) {
    activeRequests--;
  }
  if (activeRequests === 0) {
    isLoading = false;
    subscribers.forEach((cb) => cb(isLoading));
  }
};
